import { jsxs as a, jsx as e, Fragment as V } from "react/jsx-runtime";
import * as ne from "react";
import Ne, { useMemo as ue, useEffect as he, useState as Y, useRef as et, useCallback as de } from "react";
import { Alert as ie, Collapse as tt, useTheme as st, useMediaQuery as ct, alpha as De, Box as y, ButtonGroup as We, Button as N, Typography as I, LinearProgress as pe, Dialog as fe, DialogContent as ge, DialogTitle as Te, DialogActions as ke, Link as dt, Stack as q, Chip as ut, IconButton as oe, TextField as H, CircularProgress as me, Paper as rt, Drawer as ht, Divider as nt, Tooltip as pt, List as Be, ListItemButton as Ee, ListItemIcon as qe, ListItemText as Re, AlertTitle as mt, Card as Oe, CardHeader as $e, CardContent as Pe, Table as ve, TableBody as xe, TableRow as Q, TableCell as F, Skeleton as Ge, Switch as Se, ListSubheader as ft, MenuItem as Ce, FormControlLabel as Le } from "@mui/material";
import { Box as gt } from "@mui/system";
import { DataGrid as bt, GridToolbarContainer as vt, GridToolbarExport as xt } from "@mui/x-data-grid";
import yt from "@fullcalendar/react";
import St from "@fullcalendar/daygrid";
import Ct from "@fullcalendar/timegrid";
import wt from "@fullcalendar/interaction";
import { ArrowBack as At, ArrowForward as Mt, CalendarViewMonth as Tt, ViewWeek as kt, ViewDay as It, Today as Dt, PictureAsPdfOutlined as Et, InsertDriveFileOutlined as Rt, Close as Ie, EditOutlined as Ot, DeleteOutline as $t, Add as Pt, HelpOutline as Lt, Logout as zt, Class as Nt, PersonAdd as _t, Share as Wt, TrendingUp as Bt, Warning as qt, Schedule as Gt, Hub as Ft, CalendarMonth as it, Dashboard as Ht, DirectionsCar as Ut, Storefront as Yt, Business as jt, Handshake as Vt, Visibility as Zt, Map as Xt, LocationCity as Jt, LocationOn as Qt, Groups as Kt, Inventory as er, PriceChange as tr, CardGiftcard as rr, LocalOffer as nr, EventNote as ir, BugReport as or, Sync as ar, Speed as lr, ManageAccounts as sr, People as cr, School as dr, AttachMoney as ur, MenuBook as hr, EventAvailable as pr, Star as mr, ListAlt as fr, ExpandLess as gr, ExpandMore as br, Settings as vr, Check as we } from "@mui/icons-material";
import { adminTheme as Fe, LessonTypeName as xr, LANGUAGE_OPTIONS as yr } from "@coast/utils";
import Sr from "react-markdown";
import Cr from "remark-gfm";
import wr from "@mui/icons-material/Add";
import Ar from "@mui/icons-material/Delete";
import { u as ai } from "./useInterval-lF6XHzCm.js";
import { F as si, a as ci } from "./FeatureIcon-D3nxEPOL.js";
import { S as ui } from "./SwipeCarousel-Cvtmi-Xn.js";
import { L as pi } from "./LocationMap-CIgqzxQy.js";
import { R as fi, a as gi } from "./RadixMobileNav-ZfctMtc4.js";
import { A as vi, N as xi, R as yi } from "./navigationData-tFNNVAXI.js";
import { F as Ci, a as wi, S as Ai } from "./footerContent-aeZ9HyQf.js";
import { c as Ti, a as ki } from "./themeFactory-CsN7bVhg.js";
const Mr = (t, r) => /* @__PURE__ */ e(
  gt,
  {
    onClick: () => r((n) => !n),
    sx: {
      display: "inline",
      textDecoration: "underline",
      cursor: "pointer"
    },
    children: "Enter it here."
  }
);
function Rn({
  title: t,
  children: r,
  severity: n = "info",
  defaultCollapsed: i = !0,
  renderTrigger: l = Mr,
  ...c
}) {
  const [s, h] = Ne.useState(i);
  return /* @__PURE__ */ a(ie, { sx: { mb: 2 }, severity: n, "data-cy": c["data-cy"], children: [
    t,
    " ",
    l?.(s, h),
    /* @__PURE__ */ e(tt, { in: !s, timeout: "auto", unmountOnExit: !0, children: r })
  ] });
}
const Tr = "Server-side sorting is enabled but no onSortModelChange handler was provided", kr = "Server-side filtering is enabled but no onFilterModelChange handler was provided", Ir = () => /* @__PURE__ */ e(vt, { children: /* @__PURE__ */ e(
  xt,
  {
    printOptions: { disableToolbarButton: !0 },
    csvOptions: { disableToolbarButton: !1 }
  }
) }), On = ({
  rows: t,
  columns: r,
  pageSize: n = 100,
  page: i = 0,
  rowsPerPageOptions: l = [100, 200, 300],
  loading: c = !1,
  sortModel: s = [],
  totalRows: h = 0,
  dataCy: d = "",
  enableExport: u = !1,
  onSortModelChange: v,
  onFilterModelChange: b,
  onPageChange: S,
  onPageSizeChange: o,
  onRowClick: g
}) => {
  const w = n > h ? "client" : "server", R = ue(() => t.map((D, C) => ({
    ...D,
    ...D.id === void 0 && { id: `${i}-${C}` }
  })), [t, i]), P = (D) => {
    S && S(D.page), o && D.pageSize !== n && o(D.pageSize);
  };
  he(() => {
    if (w === "server") {
      const D = r.some((z) => z.serverSortable), C = r.some(
        (z) => z.serverFilterable
      );
      if (D && !v)
        throw new Error(Tr);
      if (C && !b)
        throw new Error(kr);
    }
  }, [w, r, v, b]);
  const W = ue(() => w === "client" ? r.map((D) => ({
    ...D,
    sortable: !0,
    filterable: !0
  })) : r.map((D) => ({
    ...D,
    sortable: D.serverSortable,
    filterable: D.serverFilterable
  })), [r, w]);
  return /* @__PURE__ */ e(
    bt,
    {
      rows: R,
      slotProps: {
        row: {
          "data-cy": `${d}-row`
        }
      },
      "data-cy": `${d}-table`,
      columns: W,
      paginationModel: {
        pageSize: n,
        page: i
      },
      onPaginationModelChange: P,
      pageSizeOptions: l,
      loading: c,
      disableRowSelectionOnClick: !0,
      localeText: {
        noRowsLabel: "No data found"
      },
      sortModel: s,
      onSortModelChange: v,
      onFilterModelChange: b,
      onRowClick: g,
      slots: {
        toolbar: u ? Ir : void 0
      },
      ...w === "server" ? {
        rowCount: h,
        paginationMode: "server",
        sortingMode: "server",
        filterMode: "server",
        keepNonExistentRowsSelected: !1,
        checkboxSelection: !1
      } : {
        paginationMode: "client",
        sortingMode: "client",
        filterMode: "client"
      },
      sx: {
        "& .MuiDataGrid-cell:focus": {
          outline: "none"
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "action.hover",
          ...g ? { cursor: "pointer" } : {}
        },
        bgcolor: "transparent"
      }
    },
    `${i}-${n}`
  );
};
var Dr = /* @__PURE__ */ ((t) => (t.AVAIL = "avail", t.SCHEDULE = "approvedSchedule", t.NO_AVAIL = "noAvail", t.TIME_OFF = "timeOff", t.HOLIDAY = "holiday", t.TRANSIENT = "transient", t.LESSON = "lesson", t.CLASSROOM = "classroom", t.SLOT = "slot", t))(Dr || {});
const He = [
  St,
  Ct,
  wt
], Er = [
  "dayGridMonth",
  "timeGridWeek",
  "timeGridDay"
], Rr = (t) => t.plugins ? [...He, ...t.plugins] : He, $n = ({
  isLoading: t = !1,
  interactionDisabled: r = !1,
  height: n = "850px",
  showViewSwitcher: i = !1,
  showHeader: l = !0,
  events: c,
  datesSet: s,
  enabledViews: h = Er,
  validRange: d,
  allDaySlot: u,
  showAllDay: v,
  ...b
}) => {
  const S = st(), o = ct(S.breakpoints.down("sm")), g = De(
    S.palette.divider,
    S.palette.mode === "dark" ? 0.55 : 0.9
  ), w = De(
    S.palette.divider,
    S.palette.mode === "dark" ? 0.28 : 0.45
  ), [R, P] = Y(""), W = et(null);
  Ne.useEffect(() => {
    const E = W?.current?.getApi();
    E && P(E.view.title);
  }, []);
  const D = de(
    (E) => {
      P(E.view.title), s && s(E);
    },
    [s]
  ), C = de(
    (E) => ({
      view: E.view,
      start: E.view.currentStart,
      end: E.view.currentEnd,
      startStr: E.view.currentStart.toISOString(),
      endStr: E.view.currentEnd.toISOString(),
      timeZone: E.getOption("timeZone") || "local"
    }),
    []
  ), z = () => {
    if (t || r) return;
    const E = W?.current?.getApi();
    if (!E) return;
    E.prev();
    const $ = C(E);
    D($);
  }, O = () => {
    if (t || r) return;
    const E = W?.current?.getApi();
    if (!E) return;
    E.next();
    const $ = C(E);
    D($);
  }, X = () => {
    if (t || r) return;
    const E = W?.current?.getApi();
    if (!E) return;
    E.today();
    const $ = C(E);
    D($);
  }, Z = de((E) => {
    const $ = W?.current?.getApi();
    $ && $?.changeView(E);
  }, []);
  return /* @__PURE__ */ a(V, { children: [
    /* @__PURE__ */ a(
      y,
      {
        sx: {
          display: l ? "flex" : "none",
          flexDirection: o ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          mb: 1
        },
        children: [
          /* @__PURE__ */ a(We, { variant: "contained", "aria-label": "Calendar navigation", children: [
            /* @__PURE__ */ e(
              N,
              {
                disabled: t || r,
                onClick: z,
                "data-testid": "calendar-prev-button",
                children: /* @__PURE__ */ e(At, {})
              }
            ),
            /* @__PURE__ */ e(
              N,
              {
                disabled: t || r,
                onClick: O,
                "data-testid": "calendar-next-button",
                children: /* @__PURE__ */ e(Mt, {})
              }
            )
          ] }),
          /* @__PURE__ */ e(
            I,
            {
              sx: { fontSize: "22px", textAlign: "center", color: "text.primary" },
              children: /* @__PURE__ */ e("strong", { children: R })
            }
          ),
          /* @__PURE__ */ a(y, { sx: { display: "flex", gap: 1 }, children: [
            i && /* @__PURE__ */ a(
              We,
              {
                variant: "contained",
                disabled: t || r,
                children: [
                  h.includes("dayGridMonth") && /* @__PURE__ */ e(
                    N,
                    {
                      onClick: () => Z("dayGridMonth"),
                      "data-testid": "calendar-month-button",
                      startIcon: /* @__PURE__ */ e(Tt, {}),
                      children: "Month"
                    }
                  ),
                  h.includes("timeGridWeek") && /* @__PURE__ */ e(
                    N,
                    {
                      onClick: () => Z("timeGridWeek"),
                      "data-testid": "calendar-week-button",
                      startIcon: /* @__PURE__ */ e(kt, {}),
                      children: "Week"
                    }
                  ),
                  h.includes("timeGridDay") && /* @__PURE__ */ e(
                    N,
                    {
                      onClick: () => Z("timeGridDay"),
                      "data-testid": "calendar-day-button",
                      startIcon: /* @__PURE__ */ e(It, {}),
                      children: "Day"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e(
              N,
              {
                variant: "contained",
                disabled: t || r,
                startIcon: /* @__PURE__ */ e(Dt, {}),
                onClick: X,
                "data-testid": "calendar-today-button",
                children: "Today"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a(
      y,
      {
        position: "relative",
        sx: {
          "& .fc": {
            "--fc-border-color": g,
            "--fc-neutral-bg-color": S.palette.background.default,
            "--fc-page-bg-color": S.palette.background.paper
          },
          "& .fc-theme-standard td, & .fc-theme-standard th": {
            borderColor: g
          },
          "& .fc .fc-timegrid-slot": {
            borderBottomColor: g
          },
          "& .fc .fc-timegrid-slot-minor": {
            borderBottomColor: w
          },
          ...b.eventClick ? {
            "& .fc .fc-event": {
              cursor: "pointer"
            }
          } : {}
        },
        children: [
          /* @__PURE__ */ e(
            yt,
            {
              ref: W,
              height: n,
              headerToolbar: !1,
              datesSet: D,
              plugins: Rr(b),
              events: c,
              allDaySlot: v ?? u,
              validRange: d,
              ...b,
              ...r ? {
                editable: !1,
                selectable: !1,
                eventStartEditable: !1,
                eventDurationEditable: !1,
                droppable: !1
              } : {}
            }
          ),
          t && /* @__PURE__ */ a(
            y,
            {
              sx: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                backgroundColor: De(S.palette.background.paper, 0.92),
                zIndex: 1
              },
              children: [
                /* @__PURE__ */ e(I, { color: "text.primary", children: "Loading..." }),
                /* @__PURE__ */ e(y, { sx: { width: "50%", maxWidth: "300px" }, children: /* @__PURE__ */ e(pe, {}) })
              ]
            }
          )
        ]
      }
    )
  ] });
};
function Pn(t = { isOpen: !1 }) {
  const [r, n] = Y(t), i = de((c) => {
    n({ isOpen: !0, target: c });
  }, []), l = de(() => {
    n((c) => ({ ...c, isOpen: !1, target: void 0 }));
  }, []);
  return {
    ...r,
    openFor: i,
    close: l
  };
}
function ze(t, r) {
  return t.target === void 0 ? null : r(t.target);
}
function Ln(t) {
  const { modal: r, children: n, ...i } = t;
  return /* @__PURE__ */ e(fe, { ...i, open: r.isOpen, onClose: r.close, children: /* @__PURE__ */ e(ge, { children: ze(r, n) }) });
}
function zn(t) {
  const {
    modal: r,
    title: n,
    isDisabled: i,
    isConfirmDisabled: l,
    onConfirm: c,
    children: s,
    ...h
  } = t;
  let { actionButtonLabel: d, cancelButtonLabel: u } = t;
  return d = d ?? "Delete", u = u ?? "Cancel", /* @__PURE__ */ a(fe, { ...h, open: r.isOpen, onClose: r.close, children: [
    /* @__PURE__ */ e(Te, { children: n }),
    /* @__PURE__ */ e(ge, { children: ze(r, s) }),
    ze(r, (v) => /* @__PURE__ */ a(ke, { children: [
      /* @__PURE__ */ e(
        N,
        {
          color: "primary",
          onClick: r.close,
          "data-cy": "confirmation-cancel-button",
          disabled: i,
          children: u
        }
      ),
      /* @__PURE__ */ e(
        N,
        {
          color: "primary",
          onClick: () => c(v),
          "data-cy": "confirmation-confirm-button",
          disabled: l ?? i,
          children: d
        }
      )
    ] }))
  ] });
}
function Or(t) {
  return !!t?.startsWith("image/");
}
function Ue(t) {
  return t === "application/pdf";
}
function $r(t) {
  const r = t.split(".").pop()?.trim();
  if (!(!r || r === t))
    return r.toUpperCase();
}
function Ae({
  label: t,
  contentType: r,
  url: n,
  file: i,
  onDelete: l,
  disabled: c = !1,
  width: s = 170
}) {
  const [h, d] = Y(!1), [u, v] = Y();
  he(() => {
    d(!1);
  }, [i, n]), he(() => {
    if (!i) {
      v(void 0);
      return;
    }
    const P = URL.createObjectURL(i);
    return v(P), () => {
      URL.revokeObjectURL(P);
    };
  }, [i]);
  const b = n ?? u, S = !!b && !l, o = !!b && Or(r) && !h, g = $r(t), w = g || (Ue(r) ? "PDF" : "FILE"), R = /* @__PURE__ */ a(V, { children: [
    /* @__PURE__ */ a(
      y,
      {
        sx: {
          position: "relative",
          height: 104,
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden"
        },
        children: [
          o && b ? /* @__PURE__ */ e(
            y,
            {
              component: "img",
              src: b,
              alt: t,
              onError: () => d(!0),
              sx: {
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block"
              }
            }
          ) : /* @__PURE__ */ a(q, { alignItems: "center", spacing: 0.75, children: [
            Ue(r) ? /* @__PURE__ */ e(Et, { color: "error", fontSize: "medium" }) : /* @__PURE__ */ e(Rt, { color: "action", fontSize: "medium" }),
            /* @__PURE__ */ e(
              ut,
              {
                label: w,
                size: "small",
                variant: "outlined",
                sx: {
                  height: 20,
                  "& .MuiChip-label": {
                    px: 1,
                    fontSize: "0.625rem",
                    fontWeight: 700
                  }
                }
              }
            )
          ] }),
          l ? /* @__PURE__ */ e(
            oe,
            {
              size: "small",
              disabled: c,
              "aria-label": `Remove ${t}`,
              onClick: (P) => {
                P.preventDefault(), P.stopPropagation(), l();
              },
              sx: {
                position: "absolute",
                top: 4,
                right: 4,
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                "&:hover": {
                  bgcolor: "background.default"
                }
              },
              children: /* @__PURE__ */ e(Ie, { fontSize: "small" })
            }
          ) : null
        ]
      }
    ),
    /* @__PURE__ */ a(y, { sx: { px: 1, py: 0.75 }, children: [
      /* @__PURE__ */ e(
        I,
        {
          variant: "caption",
          sx: {
            display: "block",
            fontWeight: 600,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: t
        }
      ),
      r ? /* @__PURE__ */ e(
        I,
        {
          variant: "caption",
          color: "text.secondary",
          sx: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: r
        }
      ) : null
    ] })
  ] });
  return S ? /* @__PURE__ */ e(
    dt,
    {
      href: b,
      target: "_blank",
      rel: "noreferrer noopener",
      underline: "none",
      sx: {
        display: "block",
        width: s,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        overflow: "hidden",
        color: "text.primary",
        "&:hover": {
          borderColor: "text.primary"
        }
      },
      children: R
    }
  ) : /* @__PURE__ */ e(
    y,
    {
      sx: {
        width: s,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        overflow: "hidden",
        color: "text.primary"
      },
      children: R
    }
  );
}
function ot({
  disabled: t,
  onFilesSelected: r
}) {
  return /* @__PURE__ */ a(N, { variant: "outlined", component: "label", disabled: t, children: [
    "Attach files",
    /* @__PURE__ */ e(
      "input",
      {
        hidden: !0,
        multiple: !0,
        type: "file",
        onChange: (n) => {
          r(n.target.files), n.target.value = "";
        }
      }
    )
  ] });
}
function Nn({
  notes: t,
  loading: r,
  errorMessage: n,
  hiddenNotesCount: i,
  hasHiddenNotes: l,
  isBusy: c,
  isEditingDisabled: s,
  isSavingEdit: h,
  isEditDirty: d,
  noteEditDraft: u,
  editButtonDataCy: v,
  deleteButtonDataCy: b,
  onStartEditing: S,
  onDeleteRequested: o,
  onEditDraftTextChange: g,
  onEditFilesSelected: w,
  onRemoveExistingDraftAttachment: R,
  onRemovePendingDraftAttachment: P,
  onSaveEdit: W,
  onCancelEditing: D
}) {
  return /* @__PURE__ */ a(q, { spacing: 2, children: [
    n ? /* @__PURE__ */ e(ie, { severity: "error", children: n }) : null,
    l ? /* @__PURE__ */ e(ie, { severity: "info", children: i > 0 ? `Showing the latest ${t.length} notes. ${i} older note${i === 1 ? "" : "s"} may be hidden.` : `Showing the latest ${t.length} notes. Older notes may be hidden.` }) : null,
    r ? /* @__PURE__ */ e(y, { sx: { display: "flex", justifyContent: "center", py: 2 }, children: /* @__PURE__ */ e(me, { size: 24 }) }) : null,
    !r && t.length === 0 ? /* @__PURE__ */ e(I, { variant: "body2", color: "text.secondary", children: "No notes yet." }) : null,
    t.map((C) => {
      const { note: z } = C;
      return /* @__PURE__ */ a(
        y,
        {
          sx: {
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            px: 2,
            py: 1.75,
            bgcolor: "background.paper"
          },
          children: [
            /* @__PURE__ */ a(
              q,
              {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                spacing: 1,
                sx: { mb: C.isEditing ? 1.5 : 0 },
                children: [
                  /* @__PURE__ */ a(I, { variant: "caption", color: "text.secondary", children: [
                    C.displayTimestamp,
                    C.isEdited ? " (edited)" : ""
                  ] }),
                  C.isEditing ? null : /* @__PURE__ */ a(q, { direction: "row", spacing: 0.5, children: [
                    /* @__PURE__ */ e(
                      oe,
                      {
                        size: "small",
                        onClick: () => S(z),
                        disabled: s,
                        "data-cy": v,
                        children: /* @__PURE__ */ e(Ot, { fontSize: "small" })
                      }
                    ),
                    /* @__PURE__ */ e(
                      oe,
                      {
                        size: "small",
                        onClick: () => o(z),
                        disabled: s,
                        "data-cy": b,
                        children: /* @__PURE__ */ e($t, { fontSize: "small" })
                      }
                    )
                  ] })
                ]
              }
            ),
            C.isEditing && u ? /* @__PURE__ */ a(q, { spacing: 1.5, children: [
              /* @__PURE__ */ e(
                H,
                {
                  fullWidth: !0,
                  multiline: !0,
                  minRows: 3,
                  value: u.text,
                  onChange: (O) => g(O.target.value),
                  disabled: c
                }
              ),
              /* @__PURE__ */ a(q, { direction: "row", spacing: 1, useFlexGap: !0, flexWrap: "wrap", children: [
                /* @__PURE__ */ e(
                  ot,
                  {
                    disabled: c,
                    onFilesSelected: w
                  }
                ),
                /* @__PURE__ */ e(
                  N,
                  {
                    variant: "contained",
                    color: "primary",
                    disabled: !u.text.trim() || !d || c || h,
                    onClick: W,
                    startIcon: h ? /* @__PURE__ */ e(me, { size: 16, color: "inherit" }) : null,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ e(
                  N,
                  {
                    variant: "text",
                    onClick: D,
                    disabled: c,
                    children: "Cancel"
                  }
                )
              ] }),
              u.attachmentIds.length > 0 ? /* @__PURE__ */ e(q, { direction: "row", spacing: 1, useFlexGap: !0, flexWrap: "wrap", children: u.attachmentIds.map((O) => {
                const X = C.displayAttachments.find(
                  (Z) => Z.id === O
                );
                return /* @__PURE__ */ e(
                  Ae,
                  {
                    label: X?.label ?? O,
                    url: X?.url,
                    contentType: X?.contentType,
                    onDelete: () => R(O),
                    disabled: c
                  },
                  O
                );
              }) }) : null,
              u.pendingAttachments.length > 0 ? /* @__PURE__ */ e(q, { direction: "row", spacing: 1, useFlexGap: !0, flexWrap: "wrap", children: u.pendingAttachments.map((O) => /* @__PURE__ */ e(
                Ae,
                {
                  label: O.file.name,
                  file: O.file,
                  contentType: O.file.type || void 0,
                  onDelete: () => P(O.id),
                  disabled: c
                },
                O.id
              )) }) : null
            ] }) : /* @__PURE__ */ a(V, { children: [
              /* @__PURE__ */ a(I, { variant: "caption", color: "text.secondary", children: [
                "Added by: ",
                C.createdByLabel
              ] }),
              /* @__PURE__ */ e(
                I,
                {
                  variant: "body2",
                  sx: {
                    mt: 0.75,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word"
                  },
                  children: z.text
                }
              ),
              C.displayAttachments.length > 0 ? /* @__PURE__ */ a(y, { sx: { mt: 1.25 }, children: [
                /* @__PURE__ */ a(
                  I,
                  {
                    variant: "caption",
                    color: "text.secondary",
                    sx: { display: "block", mb: 0.75, fontWeight: 600 },
                    children: [
                      "Attachments (",
                      C.displayAttachments.length,
                      ")"
                    ]
                  }
                ),
                /* @__PURE__ */ e(
                  q,
                  {
                    direction: "row",
                    spacing: 1,
                    useFlexGap: !0,
                    flexWrap: "wrap",
                    children: C.displayAttachments.map((O) => /* @__PURE__ */ e(
                      Ae,
                      {
                        label: O.label,
                        url: O.url,
                        contentType: O.contentType
                      },
                      O.id
                    ))
                  }
                )
              ] }) : null
            ] })
          ]
        },
        z.id
      );
    })
  ] });
}
function _n({
  open: t,
  isBusy: r,
  isSaving: n,
  title: i = "Add Note",
  placeholder: l = "Add a note",
  inputDataCy: c,
  text: s,
  attachments: h,
  onClose: d,
  onTextChange: u,
  onFilesSelected: v,
  onRemoveAttachment: b,
  onSave: S
}) {
  return /* @__PURE__ */ a(fe, { open: t, onClose: d, fullWidth: !0, maxWidth: "sm", children: [
    /* @__PURE__ */ e(Te, { children: i }),
    /* @__PURE__ */ e(ge, { children: /* @__PURE__ */ a(q, { spacing: 1.5, sx: { mt: 0.5 }, children: [
      /* @__PURE__ */ e(
        H,
        {
          fullWidth: !0,
          multiline: !0,
          minRows: 3,
          placeholder: l,
          value: s,
          onChange: (o) => u(o.target.value),
          disabled: r,
          "data-cy": c
        }
      ),
      /* @__PURE__ */ e(y, { children: /* @__PURE__ */ e(
        ot,
        {
          disabled: r,
          onFilesSelected: v
        }
      ) }),
      h.length > 0 ? /* @__PURE__ */ e(q, { direction: "row", spacing: 1, useFlexGap: !0, flexWrap: "wrap", children: h.map((o) => /* @__PURE__ */ e(
        Ae,
        {
          label: o.file.name,
          file: o.file,
          contentType: o.file.type || void 0,
          onDelete: () => b(o.id),
          disabled: r
        },
        o.id
      )) }) : null
    ] }) }),
    /* @__PURE__ */ a(ke, { children: [
      /* @__PURE__ */ e(N, { onClick: d, color: "inherit", disabled: r, children: "Cancel" }),
      /* @__PURE__ */ e(
        N,
        {
          variant: "contained",
          color: "primary",
          disabled: !s.trim() || r || n,
          onClick: S,
          startIcon: n ? /* @__PURE__ */ e(me, { size: 16, color: "inherit" }) : null,
          children: "Save Note"
        }
      )
    ] })
  ] });
}
function Wn({
  open: t,
  noteText: r,
  isDeleting: n,
  title: i = "Delete Note?",
  onClose: l,
  onConfirm: c
}) {
  return /* @__PURE__ */ a(fe, { open: t, onClose: l, fullWidth: !0, maxWidth: "sm", children: [
    /* @__PURE__ */ e(Te, { children: i }),
    /* @__PURE__ */ e(ge, { children: /* @__PURE__ */ e(
      I,
      {
        variant: "body2",
        sx: { whiteSpace: "pre-wrap", wordBreak: "break-word" },
        children: `Are you sure you want to delete this note: "${r ?? ""}"?`
      }
    ) }),
    /* @__PURE__ */ a(ke, { children: [
      /* @__PURE__ */ e(N, { onClick: l, color: "inherit", disabled: n, children: "Cancel" }),
      /* @__PURE__ */ e(
        N,
        {
          variant: "contained",
          color: "error",
          disabled: n,
          onClick: c,
          startIcon: n ? /* @__PURE__ */ e(me, { size: 16, color: "inherit" }) : null,
          children: "Delete"
        }
      )
    ] })
  ] });
}
function Bn({
  disabled: t,
  onClick: r,
  dataCy: n
}) {
  return /* @__PURE__ */ e(
    oe,
    {
      size: "small",
      onClick: r,
      disabled: t,
      "data-cy": n,
      children: /* @__PURE__ */ e(Pt, { fontSize: "small" })
    }
  );
}
function qn(t) {
  const { children: r, sx: n, ...i } = t;
  return /* @__PURE__ */ e(
    rt,
    {
      variant: "outlined",
      ...i,
      sx: [
        (l) => ({
          p: (l.coastline?.filter ?? Fe.filter).padding,
          backgroundColor: l.palette.background.paper
        }),
        ...Array.isArray(n) ? n : [n]
      ],
      children: /* @__PURE__ */ e(
        q,
        {
          sx: (l) => ({
            gap: (l.coastline?.filter ?? Fe.filter).gap
          }),
          children: r
        }
      )
    }
  );
}
function Gn(t) {
  const { title: r, description: n, aside: i, children: l, ...c } = t;
  return /* @__PURE__ */ a(q, { spacing: 1.5, ...c, children: [
    /* @__PURE__ */ a(
      q,
      {
        direction: { xs: "column", sm: "row" },
        spacing: 1,
        alignItems: { sm: "flex-start" },
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ a(q, { spacing: 0.5, children: [
            /* @__PURE__ */ e(
              I,
              {
                variant: "subtitle2",
                color: "text.secondary",
                sx: (s) => ({
                  textTransform: s.typography.overline.textTransform,
                  letterSpacing: s.typography.overline.letterSpacing,
                  fontWeight: s.typography.fontWeightMedium
                }),
                children: r
              }
            ),
            n ? /* @__PURE__ */ e(I, { variant: "body2", color: "text.secondary", children: n }) : null
          ] }),
          i ? /* @__PURE__ */ e(q, { children: i }) : null
        ]
      }
    ),
    l
  ] });
}
function Fn(t) {
  const { children: r, sx: n, ...i } = t;
  return /* @__PURE__ */ e(
    rt,
    {
      variant: "outlined",
      ...i,
      sx: [
        (l) => ({
          backgroundColor: l.palette.background.paper
        }),
        ...Array.isArray(n) ? n : [n]
      ],
      children: r
    }
  );
}
function Pr(t) {
  const {
    children: r,
    contentSx: n,
    footer: i,
    header: l,
    onClose: c,
    open: s,
    title: h,
    width: d = 420
  } = t, u = ne.useId();
  return /* @__PURE__ */ a(
    ht,
    {
      anchor: "right",
      open: s,
      onClose: c,
      ModalProps: { keepMounted: !0 },
      slotProps: {
        backdrop: {
          invisible: !0
        },
        paper: {
          ...l ? { "aria-label": h } : { "aria-labelledby": u },
          role: "dialog",
          sx: (v) => ({
            top: {
              xs: 56,
              sm: v.coastline.shell.headerHeight
            },
            height: {
              xs: "calc(100vh - 56px)",
              sm: `calc(100vh - ${v.coastline.shell.headerHeight}px)`
            },
            width: {
              xs: "100vw",
              sm: d
            },
            maxWidth: "100vw",
            display: "flex",
            flexDirection: "column",
            borderLeft: `1px solid ${v.palette.divider}`,
            borderTop: `1px solid ${v.palette.divider}`,
            borderTopLeftRadius: 8,
            backgroundColor: v.palette.background.paper,
            color: v.palette.text.primary,
            overflow: "hidden"
          })
        }
      },
      children: [
        l ?? /* @__PURE__ */ a(
          y,
          {
            sx: (v) => ({
              display: "flex",
              alignItems: "center",
              minHeight: 56,
              px: 2,
              borderBottom: `1px solid ${v.palette.divider}`
            }),
            children: [
              /* @__PURE__ */ e(
                I,
                {
                  id: u,
                  variant: "subtitle1",
                  fontWeight: 600,
                  flex: 1,
                  children: h
                }
              ),
              /* @__PURE__ */ e(
                oe,
                {
                  "aria-label": `Close ${h}`,
                  onClick: c,
                  edge: "end",
                  children: /* @__PURE__ */ e(Ie, {})
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          y,
          {
            sx: [
              { flex: 1, minHeight: 0, overflowY: "auto", p: 2 },
              ...Array.isArray(n) ? n : n ? [n] : []
            ],
            children: r
          }
        ),
        i && /* @__PURE__ */ a(V, { children: [
          /* @__PURE__ */ e(nt, {}),
          /* @__PURE__ */ e(y, { sx: { p: 2 }, children: i })
        ] })
      ]
    }
  );
}
function Lr(t) {
  const { children: r, footer: n, onOpen: i, title: l = "Help & Support" } = t, [c, s] = ne.useState(!1);
  return /* @__PURE__ */ a(V, { children: [
    /* @__PURE__ */ e(pt, { title: "Help & Support", children: /* @__PURE__ */ e(
      oe,
      {
        "aria-label": "Open help and support",
        color: "inherit",
        size: "small",
        onClick: () => {
          s(!0), i?.();
        },
        sx: (d) => ({
          flexShrink: 0,
          width: 36,
          height: 36,
          border: `1px solid ${d.palette.divider}`,
          borderRadius: 1,
          color: d.palette.text.primary,
          backgroundColor: d.palette.background.paper,
          "&:hover": {
            borderColor: d.palette.text.secondary,
            backgroundColor: d.palette.action.hover
          }
        }),
        children: /* @__PURE__ */ e(Lt, { fontSize: "small" })
      }
    ) }),
    /* @__PURE__ */ e(
      Pr,
      {
        open: c,
        onClose: () => s(!1),
        title: l,
        footer: n,
        children: r
      }
    )
  ] });
}
function zr(t) {
  const r = t.split(/[?#]/)[0] || "/";
  return r.length > 1 && r.endsWith("/") ? r.slice(0, -1) : r;
}
function Ye(t) {
  return zr(t).split("/").filter(Boolean);
}
function Nr(t) {
  return t.startsWith(":") || t.startsWith("[") && t.endsWith("]");
}
function _r(t, r) {
  const n = Ye(t), i = Ye(r);
  if (n.length === 0 || n.length > i.length)
    return -1;
  let l = 0;
  for (let c = 0; c < n.length; c += 1) {
    const s = n[c], h = i[c];
    if (Nr(s)) {
      l += 5;
      continue;
    }
    if (s !== h)
      return -1;
    l += 10;
  }
  return n.length === i.length && (l += 1e3), l + n.length;
}
function Wr(t, r) {
  let n, i = -1;
  return t.forEach((l) => {
    l.routePatterns.forEach((c) => {
      const s = _r(c, r);
      s > i && (n = l, i = s);
    });
  }), n;
}
function Br(t) {
  const { doc: r, status: n } = t;
  return n === "loading" ? /* @__PURE__ */ a(q, { alignItems: "center", gap: 1.5, sx: { py: 5 }, children: [
    /* @__PURE__ */ e(me, { size: 24 }),
    /* @__PURE__ */ e(I, { variant: "body2", color: "text.secondary", children: "Loading help document..." })
  ] }) : n === "error" ? /* @__PURE__ */ e(ie, { severity: "error", children: "We could not load this help document. Please try again." }) : r ? /* @__PURE__ */ e(
    y,
    {
      sx: (i) => ({
        color: i.palette.text.primary,
        fontSize: i.typography.body2.fontSize,
        lineHeight: 1.6,
        "& h1": {
          ...i.typography.h6,
          margin: i.spacing(0, 0, 2)
        },
        "& h2": {
          ...i.typography.subtitle1,
          margin: i.spacing(3, 0, 1),
          fontWeight: 700
        },
        "& h3": {
          ...i.typography.subtitle2,
          margin: i.spacing(2.5, 0, 1),
          fontWeight: 700
        },
        "& p": {
          margin: i.spacing(0, 0, 1.5)
        },
        "& ul, & ol": {
          margin: i.spacing(0, 0, 1.5),
          paddingLeft: i.spacing(3)
        },
        "& li": {
          marginBottom: i.spacing(0.5)
        },
        "& code": {
          borderRadius: 4,
          backgroundColor: i.palette.action.hover,
          padding: i.spacing(0.125, 0.5),
          fontFamily: '"Courier New", monospace'
        },
        "& pre": {
          overflowX: "auto",
          borderRadius: 4,
          backgroundColor: i.palette.action.hover,
          padding: i.spacing(1.5)
        },
        "& pre code": {
          padding: 0,
          backgroundColor: "transparent"
        },
        "& a": {
          color: i.palette.info.main
        },
        "& table": {
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: i.spacing(2)
        },
        "& th, & td": {
          border: `1px solid ${i.palette.divider}`,
          padding: i.spacing(0.75),
          verticalAlign: "top"
        },
        "& th": {
          backgroundColor: i.palette.action.hover,
          fontWeight: 700
        }
      }),
      children: /* @__PURE__ */ e(Sr, { remarkPlugins: [Cr], children: r.markdown })
    }
  ) : null;
}
function Hn(t) {
  const { currentPath: r, docs: n, loadDoc: i, onOpen: l } = t, [c, s] = ne.useState({}), [h, d] = ne.useState({}), u = ne.useMemo(
    () => Wr(n, r),
    [r, n]
  ), v = ne.useCallback(async () => {
    if (!(!u || c[u.docPath] || h[u.docPath] === "loading")) {
      d((g) => ({
        ...g,
        [u.docPath]: "loading"
      }));
      try {
        const g = await i(u.docPath);
        if (!g)
          throw new Error("Help doc request returned no document");
        s((w) => ({
          ...w,
          [g.docPath]: g
        })), d((w) => ({
          ...w,
          [g.docPath]: "loaded"
        }));
      } catch (g) {
        console.error("Unable to load admin help document", {
          docPath: u.docPath,
          error: g
        }), d((w) => ({
          ...w,
          [u.docPath]: "error"
        }));
      }
    }
  }, [c, h, i, u]);
  if (!u)
    return null;
  const b = c[u.docPath], S = h[u.docPath] ?? "idle", o = () => {
    l?.(u), v();
  };
  return /* @__PURE__ */ e(Lr, { title: u.title, onOpen: o, children: /* @__PURE__ */ e(Br, { doc: b, status: S }) });
}
const Un = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], qr = {
  day: "Monday",
  startTime: "08:00",
  endTime: "21:00"
};
function Gr(t, r, n) {
  return r >= t.length ? t.concat(n) : t.map(
    (i, l) => l === r ? n : i
  );
}
function Yn({
  ranges: t,
  onChange: r,
  days: n,
  disabled: i
}) {
  if (n.length === 0)
    throw new Error("AvailabilityRangeEditor requires at least one day");
  const l = n[0], c = {
    ...qr,
    day: l
  }, s = t.length > 0 ? t : [c];
  return /* @__PURE__ */ e(V, { children: s.map(({ day: h, startTime: d, endTime: u }, v) => {
    const b = (S) => {
      const o = t[v] ?? c;
      r(Gr(t, v, S(o)));
    };
    return /* @__PURE__ */ a(
      y,
      {
        sx: {
          alignItems: "center",
          display: "flex",
          flexWrap: "wrap",
          gap: 1
        },
        children: [
          /* @__PURE__ */ e(
            H,
            {
              disabled: i,
              select: !0,
              sx: { bgcolor: "background.paper", minWidth: 160 },
              name: "day",
              label: "Day",
              value: h,
              onChange: (S) => b((o) => ({
                ...o,
                day: S.target.value
              })),
              variant: "outlined",
              margin: "normal",
              slotProps: {
                select: {
                  native: !0
                }
              },
              children: n.map((S) => /* @__PURE__ */ e("option", { value: S, children: S }, S))
            }
          ),
          /* @__PURE__ */ e(
            H,
            {
              disabled: i,
              "data-cy": `${h}-start-time`,
              label: "Start Time",
              type: "time",
              margin: "normal",
              value: d,
              onChange: (S) => {
                b((o) => ({
                  ...o,
                  startTime: S.target.value
                }));
              },
              slotProps: {
                htmlInput: {
                  step: 300
                },
                inputLabel: {
                  shrink: !0
                }
              }
            }
          ),
          /* @__PURE__ */ e(
            H,
            {
              disabled: i,
              "data-cy": `${h}-end-time`,
              label: "End Time",
              type: "time",
              margin: "normal",
              value: u,
              onChange: (S) => {
                b((o) => ({
                  ...o,
                  endTime: S.target.value
                }));
              },
              slotProps: {
                htmlInput: {
                  step: 300
                },
                inputLabel: {
                  shrink: !0
                }
              }
            }
          ),
          s.length - 1 === v ? /* @__PURE__ */ e(
            N,
            {
              "aria-label": "Add availability range",
              disabled: i,
              variant: "contained",
              onClick: () => r(t.concat(c)),
              sx: {
                borderRadius: 1,
                height: 40,
                minWidth: 40,
                px: 1
              },
              children: /* @__PURE__ */ e(wr, {})
            }
          ) : /* @__PURE__ */ e(
            oe,
            {
              "aria-label": "Remove availability range",
              disabled: i,
              color: "primary",
              onClick: () => r(
                t.filter((S, o) => v !== o)
              ),
              sx: { borderRadius: 1 },
              children: /* @__PURE__ */ e(Ar, {})
            }
          )
        ]
      },
      v
    );
  }) });
}
const K = (t) => {
  const r = t.match(/(\d{1,2}):(\d{2})\s*(am|pm)?/i);
  if (!r)
    return 0;
  const [, n, i, l] = r, c = parseInt(n, 10) * 60 + parseInt(i, 10);
  if (l) {
    const s = l.toLowerCase();
    if (s === "pm" && n !== "12")
      return c + 720;
    if (s === "am" && n === "12")
      return c - 720;
  }
  return c;
}, Fr = (t, r) => {
  const n = K(t);
  return K(r) - n;
}, Hr = (t, r, n) => {
  const l = Fr(t, r) / 60 * 240;
  return Math.max(n, l);
}, Ur = ({ gapMinutes: t }) => {
  const r = Math.floor(t / 60), n = t % 60, i = r > 0 ? `${r}h ${n}m gap` : `${n}m gap`;
  return /* @__PURE__ */ e(
    y,
    {
      sx: {
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "action.hover",
        borderBottom: "1px solid",
        borderColor: "divider"
      },
      children: /* @__PURE__ */ e(I, { variant: "caption", color: "text.secondary", children: i })
    }
  );
}, jn = ({
  events: t,
  minEventHeight: r = 80,
  sidebarWidth: n = 60,
  minGapThreshold: i = 10
}) => {
  const l = ue(
    () => [...t].sort(
      (s, h) => K(s.startTime) - K(h.startTime)
    ),
    [t]
  ), c = ue(
    () => l.map(
      (s) => Hr(s.startTime, s.endTime, r)
    ),
    [l, r]
  );
  return /* @__PURE__ */ a(y, { sx: { display: "flex", width: "100%" }, children: [
    /* @__PURE__ */ e(
      y,
      {
        sx: {
          width: n,
          flexShrink: 0,
          borderRight: "1px solid",
          borderColor: "divider",
          position: "relative"
        }
      }
    ),
    /* @__PURE__ */ e(y, { sx: { flex: 1 }, children: l.map((s, h) => {
      const d = h > 0 && K(s.startTime) - K(l[h - 1].endTime) >= i, u = h > 0 ? K(s.startTime) - K(l[h - 1].endTime) : 0, v = c[h], b = h > 0 && l[h - 1].endTime === s.startTime, S = h < l.length - 1 && s.endTime === l[h + 1].startTime;
      return /* @__PURE__ */ a(Ne.Fragment, { children: [
        d && /* @__PURE__ */ e(y, { sx: { position: "relative" }, children: /* @__PURE__ */ e(Ur, { gapMinutes: u }) }),
        /* @__PURE__ */ a(
          y,
          {
            sx: {
              display: "flex",
              minHeight: v,
              position: "relative",
              borderBottom: "1px solid",
              borderColor: "divider"
            },
            children: [
              /* @__PURE__ */ a(
                y,
                {
                  sx: {
                    position: "absolute",
                    left: -n,
                    width: n,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  },
                  children: [
                    b ? /* @__PURE__ */ e(y, { sx: { flexGrow: 0 } }) : /* @__PURE__ */ a(
                      y,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          width: "100%"
                        },
                        "data-cy": "timeline-start-time",
                        children: [
                          /* @__PURE__ */ e(
                            I,
                            {
                              variant: "caption",
                              sx: {
                                width: n - 16,
                                pr: 1,
                                textAlign: "right"
                              },
                              children: s.startTime
                            }
                          ),
                          /* @__PURE__ */ e(
                            y,
                            {
                              sx: {
                                position: "absolute",
                                right: 0,
                                width: 16,
                                borderTop: "1px solid",
                                borderColor: "divider"
                              }
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ a(
                      y,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          width: "100%",
                          ...S && {
                            position: "absolute",
                            bottom: -11,
                            // Offset to align with the border
                            zIndex: 2
                          }
                        },
                        "data-cy": "timeline-end-time",
                        children: [
                          /* @__PURE__ */ e(
                            I,
                            {
                              variant: "caption",
                              sx: {
                                width: n - 16,
                                pr: 1,
                                textAlign: "right"
                              },
                              children: s.endTime
                            }
                          ),
                          /* @__PURE__ */ e(
                            y,
                            {
                              sx: {
                                position: "absolute",
                                right: 0,
                                width: 16,
                                borderTop: "1px solid",
                                borderColor: "divider"
                              }
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ e(
                y,
                {
                  sx: {
                    flex: 1,
                    p: 1,
                    display: "flex",
                    minHeight: "100%"
                  },
                  "data-cy": "timeline-event-content",
                  children: s.component
                }
              )
            ]
          }
        )
      ] }, s.id);
    }) })
  ] });
}, Yr = "#9c27b0", Vn = ({
  title: t,
  subtitle: r,
  onClick: n,
  backgroundColor: i = Yr
}) => /* @__PURE__ */ a(
  y,
  {
    onClick: n,
    sx: {
      backgroundColor: i,
      color: "white",
      p: 1,
      borderRadius: 1,
      cursor: n ? "pointer" : "default",
      flex: 1,
      width: "100%",
      height: "100%",
      "&:hover": n ? {
        filter: "brightness(0.95)"
      } : void 0
    },
    children: [
      /* @__PURE__ */ e(I, { variant: "subtitle1", children: t }),
      r && /* @__PURE__ */ e(I, { variant: "body2", children: r })
    ]
  }
);
var jr = /* @__PURE__ */ ((t) => (t.Admin = "Admin", t.SuperAdmin = "SuperAdmin", t.OperationsManager = "OperationsManager", t))(jr || {});
const Vr = [
  {
    id: "instructors",
    label: "Instructors",
    path: "/admin/super/instructors",
    icon: /* @__PURE__ */ e(cr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "students",
    label: "Students",
    path: "/admin/super/students",
    icon: /* @__PURE__ */ e(dr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "price-lookup",
    label: "Price Lookup",
    path: "/admin/super/price-lookup",
    icon: /* @__PURE__ */ e(ur, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "lessons",
    label: "Lessons",
    path: "/admin/super/lessons",
    icon: /* @__PURE__ */ e(hr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "book-calendar",
    label: "Book Calendar",
    path: "/admin/super/book-calendar",
    icon: /* @__PURE__ */ e(it, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "book-calendar-v2",
    label: "Book Calendar V2",
    path: "/future/admin/book-lessons",
    icon: /* @__PURE__ */ e(pr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "reviews",
    label: "Reviews",
    path: "/admin/super/reviews",
    icon: /* @__PURE__ */ e(mr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "canceled-log",
    label: "Canceled Log",
    path: "/admin/super/canceled",
    icon: /* @__PURE__ */ e(fr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  }
], Zr = [
  {
    id: "class-cohorts",
    label: "Class Cohorts",
    path: "/admin/super/classes",
    icon: /* @__PURE__ */ e(Nt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "new-students",
    label: "New Students",
    path: "/admin/super/new-students",
    icon: /* @__PURE__ */ e(_t, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "shared-lessons",
    label: "Shared Lessons",
    path: "/admin/super/shared-lessons",
    icon: /* @__PURE__ */ e(Wt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "program-progress",
    label: "Program Progress",
    path: "/future/admin/program-progress",
    icon: /* @__PURE__ */ e(Bt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  }
], Xr = [
  {
    id: "instructor-alerts",
    label: "Instructor Alerts",
    path: "/future/admin/instructor-alerts",
    icon: /* @__PURE__ */ e(qt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "instructor-schedules",
    label: "Instructor Schedules",
    path: "/admin/super/instructor-schedules",
    icon: /* @__PURE__ */ e(Gt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  }
], Jr = [
  {
    id: "hubs",
    label: "Hubs",
    path: "/admin/super/hubs",
    icon: /* @__PURE__ */ e(Ft, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "vehicle-calendar",
    label: "Vehicle Calendar",
    path: "/future/admin/vehicle-calendar",
    icon: /* @__PURE__ */ e(it, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "om-dashboard",
    label: "OM Dashboard",
    path: "/future/admin/om-dashboard",
    icon: /* @__PURE__ */ e(Ht, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "vehicles",
    label: "Vehicles",
    path: "/future/admin/vehicles",
    icon: /* @__PURE__ */ e(Ut, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-vendors",
    label: "Vendors",
    path: "/future/admin/vendors",
    icon: /* @__PURE__ */ e(Yt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "org-partners",
    label: "Org. Partners",
    path: "/future/admin/org-partners",
    icon: /* @__PURE__ */ e(jt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-acquisitions",
    label: "Acquisitions",
    path: "/future/admin/acquisitions",
    icon: /* @__PURE__ */ e(Vt, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "trainee-observations",
    label: "Trainee Scheduling",
    path: "/future/admin/trainee-observations",
    icon: /* @__PURE__ */ e(Zt, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  }
], Qr = [
  {
    id: "states",
    label: "States",
    path: "/future/admin/states",
    icon: /* @__PURE__ */ e(Xt, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "next-metros",
    label: "Metros",
    path: "/future/admin/metros",
    icon: /* @__PURE__ */ e(Jt, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "next-locations",
    label: "Locations",
    path: "/future/admin/locations",
    icon: /* @__PURE__ */ e(Qt, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "next-livestream-groups",
    label: "Livestream Groups",
    path: "/future/admin/livestream-groups",
    icon: /* @__PURE__ */ e(Kt, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "next-products",
    label: "Products",
    path: "/future/admin/products",
    icon: /* @__PURE__ */ e(er, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "next-price-schemes",
    label: "Price Schemes",
    path: "/future/admin/price-schemes",
    icon: /* @__PURE__ */ e(tr, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  },
  {
    id: "vouchers",
    label: "Vouchers",
    path: "/admin/super/vouchers",
    icon: /* @__PURE__ */ e(rr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-coupons",
    label: "Coupons",
    path: "/future/admin/coupons",
    icon: /* @__PURE__ */ e(nr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  }
], Kr = [
  {
    id: "event-log",
    label: "Event Log",
    path: "/admin/super/event-log",
    icon: /* @__PURE__ */ e(ir, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "debug-schedules",
    label: "Debug Schedules",
    path: "/admin/super/scheduler",
    icon: /* @__PURE__ */ e(or, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-sync-status",
    label: "Ledger Status",
    path: "/future/admin/sync-status",
    icon: /* @__PURE__ */ e(ar, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-telemetry",
    label: "Telemetry",
    path: "/future/admin/telemetry",
    icon: /* @__PURE__ */ e(lr, { fontSize: "small" }),
    roles: [
      "Admin"
      /* Admin */
    ]
  },
  {
    id: "next-users",
    label: "Users",
    path: "/future/admin/users",
    icon: /* @__PURE__ */ e(sr, { fontSize: "small" }),
    roles: [
      "SuperAdmin"
      /* SuperAdmin */
    ]
  }
], je = [
  {
    id: "students",
    title: "Students",
    items: Zr
  },
  {
    id: "instructors",
    title: "Instructors",
    items: Xr
  },
  {
    id: "ops",
    title: "Ops",
    items: Jr
  },
  {
    id: "places-and-prices",
    title: "Places & Prices",
    items: Qr
  },
  {
    id: "engineering",
    title: "Engineering",
    items: Kr
  }
], en = {
  id: "settings",
  label: "Settings",
  path: "/future/admin/settings",
  icon: /* @__PURE__ */ e(vr, { fontSize: "small" })
}, Ve = (t) => {
  const { nav: r } = t.coastline;
  return {
    mx: r.itemMarginX,
    my: r.itemMarginY,
    borderRadius: r.itemBorderRadius,
    color: t.palette.text.secondary,
    transition: "all 0.2s ease-in-out",
    "&.Mui-selected": {
      backgroundColor: t.palette.action.selected,
      color: t.palette.text.primary,
      "&:hover": {
        backgroundColor: t.palette.action.selected
      },
      "& .MuiListItemIcon-root": {
        color: t.palette.text.primary
      },
      "& .MuiListItemText-primary": {
        fontWeight: 600,
        color: t.palette.text.primary
      }
    },
    "&:hover": {
      backgroundColor: t.palette.action.hover,
      color: t.palette.text.primary,
      "& .MuiListItemIcon-root": {
        color: t.palette.text.primary
      }
    }
  };
}, tn = (t) => {
  const { nav: r } = t.coastline;
  return {
    mx: r.itemMarginX,
    my: r.groupMarginY,
    borderRadius: r.itemBorderRadius,
    color: t.palette.text.secondary,
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "transparent",
      color: t.palette.text.primary,
      "& .MuiListItemIcon-root": {
        color: t.palette.text.primary
      }
    }
  };
}, rn = (t) => ({
  m: 0,
  "& .MuiListItemText-primary": {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: t.palette.text.secondary,
    transition: "color 0.2s ease-in-out"
  }
}), Ze = (t) => ({
  m: 0,
  "& .MuiListItemText-primary": {
    fontSize: "0.875rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: t.palette.text.secondary
  }
}), Xe = (t) => ({
  minWidth: 32,
  color: t.palette.action.active,
  transition: "color 0.2s"
}), Zn = ({
  userRoles: t,
  currentPath: r,
  onItemClick: n,
  onSignOut: i
}) => {
  const l = (o, g) => !o || o.length === 0 ? !0 : o.some((w) => g.includes(w)), c = (o, g) => o.some((w) => g.indexOf(w.path) >= 0), s = (o) => o !== "/" && r.indexOf(o) >= 0, [h, d] = ne.useState(
    () => {
      const o = {};
      return je.forEach((g) => {
        const w = g.items.filter(
          (R) => l(R.roles, t)
        );
        w.length > 0 && (o[g.id] = c(w, r));
      }), o;
    }
  ), u = (o) => {
    d((g) => ({
      ...g,
      [o]: !g[o]
    }));
  }, v = (o, g = 2) => l(o.roles, t) ? /* @__PURE__ */ a(
    Ee,
    {
      selected: s(o.path),
      onClick: () => n(o),
      sx: (w) => ({
        ...Ve(w),
        pl: g
      }),
      children: [
        o.icon && /* @__PURE__ */ e(qe, { sx: Xe, children: o.icon }),
        /* @__PURE__ */ e(Re, { primary: o.label, sx: Ze })
      ]
    },
    o.id
  ) : null, b = (o) => {
    const g = o.items.filter(
      (R) => l(R.roles, t)
    );
    if (g.length === 0) return null;
    const w = h[o.id] || !1;
    return /* @__PURE__ */ a(y, { sx: { mb: 1 }, children: [
      /* @__PURE__ */ a(
        Ee,
        {
          onClick: () => u(o.id),
          sx: tn,
          children: [
            /* @__PURE__ */ e(Re, { primary: o.title, sx: rn }),
            w ? /* @__PURE__ */ e(
              gr,
              {
                sx: (R) => ({
                  fontSize: 18,
                  color: R.palette.text.secondary
                })
              }
            ) : /* @__PURE__ */ e(
              br,
              {
                sx: (R) => ({
                  fontSize: 18,
                  color: R.palette.text.secondary
                })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ e(tt, { in: w, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ e(Be, { component: "div", disablePadding: !0, children: g.map((R) => v(R, 2)) }) })
    ] }, o.id);
  }, S = Vr.filter(
    (o) => l(o.roles, t)
  );
  return /* @__PURE__ */ a(
    Be,
    {
      component: "nav",
      sx: (o) => ({
        px: o.coastline.nav.listPaddingX,
        pt: {
          xs: 0.5,
          md: o.coastline.nav.listPaddingY
        },
        pb: o.coastline.nav.listPaddingY
      }),
      children: [
        /* @__PURE__ */ e(y, { sx: { mb: 1.5 }, children: S.map((o) => v(o)) }),
        je.map((o) => b(o)),
        /* @__PURE__ */ e(
          nt,
          {
            sx: (o) => ({
              m: 1.5,
              borderColor: o.palette.divider
            })
          }
        ),
        v(en),
        i && /* @__PURE__ */ a(Ee, { onClick: i, sx: Ve, children: [
          /* @__PURE__ */ e(qe, { sx: Xe, children: /* @__PURE__ */ e(zt, { fontSize: "small" }) }),
          /* @__PURE__ */ e(Re, { primary: "Sign Out", sx: Ze })
        ] })
      ]
    }
  );
};
function nn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Me = { exports: {} }, on = Me.exports, Je;
function an() {
  return Je || (Je = 1, (function(t, r) {
    (function(n, i) {
      t.exports = i();
    })(on, (function() {
      var n = 1e3, i = 6e4, l = 36e5, c = "millisecond", s = "second", h = "minute", d = "hour", u = "day", v = "week", b = "month", S = "quarter", o = "year", g = "date", w = "Invalid Date", R = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, P = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, W = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
        var f = ["th", "st", "nd", "rd"], p = A % 100;
        return "[" + A + (f[(p - 20) % 10] || f[p] || f[0]) + "]";
      } }, D = function(A, f, p) {
        var x = String(A);
        return !x || x.length >= f ? A : "" + Array(f + 1 - x.length).join(p) + A;
      }, C = { s: D, z: function(A) {
        var f = -A.utcOffset(), p = Math.abs(f), x = Math.floor(p / 60), m = p % 60;
        return (f <= 0 ? "+" : "-") + D(x, 2, "0") + ":" + D(m, 2, "0");
      }, m: function A(f, p) {
        if (f.date() < p.date()) return -A(p, f);
        var x = 12 * (p.year() - f.year()) + (p.month() - f.month()), m = f.clone().add(x, b), M = p - m < 0, T = f.clone().add(x + (M ? -1 : 1), b);
        return +(-(x + (p - m) / (M ? m - T : T - m)) || 0);
      }, a: function(A) {
        return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
      }, p: function(A) {
        return { M: b, y: o, w: v, d: u, D: g, h: d, m: h, s, ms: c, Q: S }[A] || String(A || "").toLowerCase().replace(/s$/, "");
      }, u: function(A) {
        return A === void 0;
      } }, z = "en", O = {};
      O[z] = W;
      var X = "$isDayjsObject", Z = function(A) {
        return A instanceof ae || !(!A || !A[X]);
      }, E = function A(f, p, x) {
        var m;
        if (!f) return z;
        if (typeof f == "string") {
          var M = f.toLowerCase();
          O[M] && (m = M), p && (O[M] = p, m = M);
          var T = f.split("-");
          if (!m && T.length > 1) return A(T[0]);
        } else {
          var L = f.name;
          O[L] = f, m = L;
        }
        return !x && m && (z = m), m || !x && z;
      }, $ = function(A, f) {
        if (Z(A)) return A.clone();
        var p = typeof f == "object" ? f : {};
        return p.date = A, p.args = arguments, new ae(p);
      }, k = C;
      k.l = E, k.i = Z, k.w = function(A, f) {
        return $(A, { locale: f.$L, utc: f.$u, x: f.$x, $offset: f.$offset });
      };
      var ae = (function() {
        function A(p) {
          this.$L = E(p.locale, null, !0), this.parse(p), this.$x = this.$x || p.x || {}, this[X] = !0;
        }
        var f = A.prototype;
        return f.parse = function(p) {
          this.$d = (function(x) {
            var m = x.date, M = x.utc;
            if (m === null) return /* @__PURE__ */ new Date(NaN);
            if (k.u(m)) return /* @__PURE__ */ new Date();
            if (m instanceof Date) return new Date(m);
            if (typeof m == "string" && !/Z$/i.test(m)) {
              var T = m.match(R);
              if (T) {
                var L = T[2] - 1 || 0, _ = (T[7] || "0").substring(0, 3);
                return M ? new Date(Date.UTC(T[1], L, T[3] || 1, T[4] || 0, T[5] || 0, T[6] || 0, _)) : new Date(T[1], L, T[3] || 1, T[4] || 0, T[5] || 0, T[6] || 0, _);
              }
            }
            return new Date(m);
          })(p), this.init();
        }, f.init = function() {
          var p = this.$d;
          this.$y = p.getFullYear(), this.$M = p.getMonth(), this.$D = p.getDate(), this.$W = p.getDay(), this.$H = p.getHours(), this.$m = p.getMinutes(), this.$s = p.getSeconds(), this.$ms = p.getMilliseconds();
        }, f.$utils = function() {
          return k;
        }, f.isValid = function() {
          return this.$d.toString() !== w;
        }, f.isSame = function(p, x) {
          var m = $(p);
          return this.startOf(x) <= m && m <= this.endOf(x);
        }, f.isAfter = function(p, x) {
          return $(p) < this.startOf(x);
        }, f.isBefore = function(p, x) {
          return this.endOf(x) < $(p);
        }, f.$g = function(p, x, m) {
          return k.u(p) ? this[x] : this.set(m, p);
        }, f.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, f.valueOf = function() {
          return this.$d.getTime();
        }, f.startOf = function(p, x) {
          var m = this, M = !!k.u(x) || x, T = k.p(p), L = function(te, U) {
            var J = k.w(m.$u ? Date.UTC(m.$y, U, te) : new Date(m.$y, U, te), m);
            return M ? J : J.endOf(u);
          }, _ = function(te, U) {
            return k.w(m.toDate()[te].apply(m.toDate("s"), (M ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(U)), m);
          }, B = this.$W, G = this.$M, j = this.$D, le = "set" + (this.$u ? "UTC" : "");
          switch (T) {
            case o:
              return M ? L(1, 0) : L(31, 11);
            case b:
              return M ? L(1, G) : L(0, G + 1);
            case v:
              var ee = this.$locale().weekStart || 0, se = (B < ee ? B + 7 : B) - ee;
              return L(M ? j - se : j + (6 - se), G);
            case u:
            case g:
              return _(le + "Hours", 0);
            case d:
              return _(le + "Minutes", 1);
            case h:
              return _(le + "Seconds", 2);
            case s:
              return _(le + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, f.endOf = function(p) {
          return this.startOf(p, !1);
        }, f.$set = function(p, x) {
          var m, M = k.p(p), T = "set" + (this.$u ? "UTC" : ""), L = (m = {}, m[u] = T + "Date", m[g] = T + "Date", m[b] = T + "Month", m[o] = T + "FullYear", m[d] = T + "Hours", m[h] = T + "Minutes", m[s] = T + "Seconds", m[c] = T + "Milliseconds", m)[M], _ = M === u ? this.$D + (x - this.$W) : x;
          if (M === b || M === o) {
            var B = this.clone().set(g, 1);
            B.$d[L](_), B.init(), this.$d = B.set(g, Math.min(this.$D, B.daysInMonth())).$d;
          } else L && this.$d[L](_);
          return this.init(), this;
        }, f.set = function(p, x) {
          return this.clone().$set(p, x);
        }, f.get = function(p) {
          return this[k.p(p)]();
        }, f.add = function(p, x) {
          var m, M = this;
          p = Number(p);
          var T = k.p(x), L = function(G) {
            var j = $(M);
            return k.w(j.date(j.date() + Math.round(G * p)), M);
          };
          if (T === b) return this.set(b, this.$M + p);
          if (T === o) return this.set(o, this.$y + p);
          if (T === u) return L(1);
          if (T === v) return L(7);
          var _ = (m = {}, m[h] = i, m[d] = l, m[s] = n, m)[T] || 1, B = this.$d.getTime() + p * _;
          return k.w(B, this);
        }, f.subtract = function(p, x) {
          return this.add(-1 * p, x);
        }, f.format = function(p) {
          var x = this, m = this.$locale();
          if (!this.isValid()) return m.invalidDate || w;
          var M = p || "YYYY-MM-DDTHH:mm:ssZ", T = k.z(this), L = this.$H, _ = this.$m, B = this.$M, G = m.weekdays, j = m.months, le = m.meridiem, ee = function(U, J, ce, be) {
            return U && (U[J] || U(x, M)) || ce[J].slice(0, be);
          }, se = function(U) {
            return k.s(L % 12 || 12, U, "0");
          }, te = le || function(U, J, ce) {
            var be = U < 12 ? "AM" : "PM";
            return ce ? be.toLowerCase() : be;
          };
          return M.replace(P, (function(U, J) {
            return J || (function(ce) {
              switch (ce) {
                case "YY":
                  return String(x.$y).slice(-2);
                case "YYYY":
                  return k.s(x.$y, 4, "0");
                case "M":
                  return B + 1;
                case "MM":
                  return k.s(B + 1, 2, "0");
                case "MMM":
                  return ee(m.monthsShort, B, j, 3);
                case "MMMM":
                  return ee(j, B);
                case "D":
                  return x.$D;
                case "DD":
                  return k.s(x.$D, 2, "0");
                case "d":
                  return String(x.$W);
                case "dd":
                  return ee(m.weekdaysMin, x.$W, G, 2);
                case "ddd":
                  return ee(m.weekdaysShort, x.$W, G, 3);
                case "dddd":
                  return G[x.$W];
                case "H":
                  return String(L);
                case "HH":
                  return k.s(L, 2, "0");
                case "h":
                  return se(1);
                case "hh":
                  return se(2);
                case "a":
                  return te(L, _, !0);
                case "A":
                  return te(L, _, !1);
                case "m":
                  return String(_);
                case "mm":
                  return k.s(_, 2, "0");
                case "s":
                  return String(x.$s);
                case "ss":
                  return k.s(x.$s, 2, "0");
                case "SSS":
                  return k.s(x.$ms, 3, "0");
                case "Z":
                  return T;
              }
              return null;
            })(U) || T.replace(":", "");
          }));
        }, f.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, f.diff = function(p, x, m) {
          var M, T = this, L = k.p(x), _ = $(p), B = (_.utcOffset() - this.utcOffset()) * i, G = this - _, j = function() {
            return k.m(T, _);
          };
          switch (L) {
            case o:
              M = j() / 12;
              break;
            case b:
              M = j();
              break;
            case S:
              M = j() / 3;
              break;
            case v:
              M = (G - B) / 6048e5;
              break;
            case u:
              M = (G - B) / 864e5;
              break;
            case d:
              M = G / l;
              break;
            case h:
              M = G / i;
              break;
            case s:
              M = G / n;
              break;
            default:
              M = G;
          }
          return m ? M : k.a(M);
        }, f.daysInMonth = function() {
          return this.endOf(b).$D;
        }, f.$locale = function() {
          return O[this.$L];
        }, f.locale = function(p, x) {
          if (!p) return this.$L;
          var m = this.clone(), M = E(p, x, !0);
          return M && (m.$L = M), m;
        }, f.clone = function() {
          return k.w(this.$d, this);
        }, f.toDate = function() {
          return new Date(this.valueOf());
        }, f.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, f.toISOString = function() {
          return this.$d.toISOString();
        }, f.toString = function() {
          return this.$d.toUTCString();
        }, A;
      })(), _e = ae.prototype;
      return $.prototype = _e, [["$ms", c], ["$s", s], ["$m", h], ["$H", d], ["$W", u], ["$M", b], ["$y", o], ["$D", g]].forEach((function(A) {
        _e[A[1]] = function(f) {
          return this.$g(f, A[0], A[1]);
        };
      })), $.extend = function(A, f) {
        return A.$i || (A(f, ae, $), A.$i = !0), $;
      }, $.locale = E, $.isDayjs = Z, $.unix = function(A) {
        return $(1e3 * A);
      }, $.en = O[z], $.Ls = O, $.p = {}, $;
    }));
  })(Me)), Me.exports;
}
var ln = an();
const at = /* @__PURE__ */ nn(ln), ye = {
  NotApplicable: "NOT_APPLICABLE",
  OnTrack: "ON_TRACK",
  Expired: "EXPIRED",
  Completed: "COMPLETED"
};
function Qe(t, r) {
  return {
    hoursRequired: t / 60,
    hoursCompleted: Math.round(r / 60 * 10) / 10,
    progress: t > 0 ? Math.min(r / t * 100, 100) : 0
  };
}
function Xn({
  deadline: t,
  isLoading: r
}) {
  if (r || !t) return null;
  const { status: n, daysRemaining: i, deadlineDate: l, requirements: c } = t;
  if (n === ye.NotApplicable)
    return null;
  const s = l ? at(l).format("MMMM D, YYYY") : "Unknown", h = n === ye.Expired, d = n === ye.OnTrack, u = n === ye.Completed, v = u || d ? "success" : h ? "error" : "warning", b = i === void 0 ? "Program Deadline" : `Program Deadline: ${i} Day${i === 1 ? "" : "s"} Remaining`, o = u ? "Program Requirements Completed" : d ? b : h ? "Program Deadline Has Passed" : b, g = c?.drivingMinutesRequired ?? 0, w = Qe(
    g,
    c?.drivingMinutesCompleted ?? 0
  ), R = c?.observationMinutesRequired ?? 0, P = Qe(
    R,
    c?.observationMinutesCompleted ?? 0
  );
  return /* @__PURE__ */ a(ie, { severity: v, sx: { mb: 2 }, "data-cy": "program-deadline-banner", children: [
    /* @__PURE__ */ e(mt, { children: o }),
    /* @__PURE__ */ e(I, { variant: "body2", children: u ? /* @__PURE__ */ e(V, { children: "All program requirements have been completed." }) : h ? /* @__PURE__ */ a(V, { children: [
      "The deadline of ",
      s,
      " has passed and requirements are not complete."
    ] }) : d ? /* @__PURE__ */ a(V, { children: [
      "You're on track! The program must be completed by",
      " ",
      s,
      "."
    ] }) : /* @__PURE__ */ a(V, { children: [
      "The program must be completed by ",
      s,
      "."
    ] }) }),
    c && /* @__PURE__ */ a(y, { sx: { mt: 2 }, children: [
      c.requiresCourseCompletion && /* @__PURE__ */ e(y, { sx: { mb: 1 }, children: /* @__PURE__ */ a(I, { variant: "body2", children: [
        "Classroom:",
        " ",
        c.courseCompleted ? /* @__PURE__ */ a(V, { children: [
          /* @__PURE__ */ e(
            we,
            {
              sx: { fontSize: 16, verticalAlign: "middle", mr: 0.5 }
            }
          ),
          "Complete"
        ] }) : /* @__PURE__ */ a(V, { children: [
          /* @__PURE__ */ e(
            Ie,
            {
              sx: { fontSize: 16, verticalAlign: "middle", mr: 0.5 }
            }
          ),
          "Incomplete"
        ] })
      ] }) }),
      g > 0 && /* @__PURE__ */ a(y, { sx: { mb: 1 }, children: [
        /* @__PURE__ */ a(I, { variant: "body2", children: [
          "Driving: ",
          w.hoursCompleted,
          "h / ",
          w.hoursRequired,
          "h",
          c.drivingComplete && /* @__PURE__ */ e(
            we,
            {
              sx: { fontSize: 16, verticalAlign: "middle", ml: 0.5 }
            }
          )
        ] }),
        /* @__PURE__ */ e(
          pe,
          {
            variant: "determinate",
            value: w.progress,
            sx: { height: 8, borderRadius: 1, mt: 0.5 }
          }
        )
      ] }),
      R > 0 && /* @__PURE__ */ a(y, { children: [
        /* @__PURE__ */ a(I, { variant: "body2", children: [
          "Observation: ",
          P.hoursCompleted,
          "h /",
          " ",
          P.hoursRequired,
          "h",
          c.observationComplete && /* @__PURE__ */ e(
            we,
            {
              sx: { fontSize: 16, verticalAlign: "middle", ml: 0.5 }
            }
          )
        ] }),
        /* @__PURE__ */ e(
          pe,
          {
            variant: "determinate",
            value: P.progress,
            sx: { height: 8, borderRadius: 1, mt: 0.5 }
          }
        )
      ] })
    ] })
  ] });
}
const re = {
  color: "text.secondary",
  width: "40%",
  verticalAlign: "top"
};
function Ke(t, r) {
  return {
    hoursRequired: t / 60,
    hoursCompleted: Math.round(r / 60 * 10) / 10,
    progressPercent: t > 0 ? Math.min(r / t * 100, 100) : 0
  };
}
function sn(t) {
  const r = t?.trim().toUpperCase();
  if (!r)
    return "Missing";
  switch (r) {
    case "COMPLETED":
      return "Completed";
    case "IN_PROGRESS":
    case "INPROGRESS":
      return "In progress";
    case "NOT_STARTED":
    case "NOTSTARTED":
      return "Not started";
    case "NOT_REQUIRED":
    case "NOTREQUIRED":
      return "Not required";
    default:
      return "Unknown";
  }
}
function cn(t) {
  if (!t) return "Not available";
  const r = at(t);
  return r.isValid() ? r.format("MMMM D, YYYY") : "Not available";
}
function Jn({
  progress: t,
  isLoading: r,
  errorMessage: n,
  onRetryError: i,
  onOpenDocumentsClick: l,
  documentsActionLabel: c = "Review documents section",
  showAdminReview: s = !1,
  cardElevation: h = 2,
  cardSx: d,
  roadTestBookingApproval: u
}) {
  const [v, b] = Y(!1), S = [
    {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "common.white",
      backgroundImage: "none"
    },
    ...d ? Array.isArray(d) ? d : [d] : []
  ];
  if (r)
    return /* @__PURE__ */ a(Oe, { elevation: h, sx: S, children: [
      /* @__PURE__ */ e(
        $e,
        {
          title: /* @__PURE__ */ e(I, { variant: "h6", children: "Road Test Eligibility Requirements" })
        }
      ),
      /* @__PURE__ */ e(Pe, { sx: { pt: 0 }, children: /* @__PURE__ */ e(ve, { size: "small", sx: { tableLayout: "fixed", width: "100%" }, children: /* @__PURE__ */ e(xe, { children: [0, 1, 2].map((k) => /* @__PURE__ */ a(Q, { children: [
        /* @__PURE__ */ e(F, { sx: re, children: /* @__PURE__ */ e(Ge, { variant: "text", width: "70%" }) }),
        /* @__PURE__ */ e(F, { children: /* @__PURE__ */ e(Ge, { variant: "text", width: "85%" }) })
      ] }, k)) }) }) })
    ] });
  if (n)
    return /* @__PURE__ */ a(Oe, { elevation: h, sx: S, children: [
      /* @__PURE__ */ e(
        $e,
        {
          title: /* @__PURE__ */ e(I, { variant: "h6", children: "Road Test Eligibility Requirements" })
        }
      ),
      /* @__PURE__ */ a(Pe, { sx: { pt: 0 }, children: [
        /* @__PURE__ */ e(I, { variant: "subtitle1", color: "error.main", sx: { mb: 1 }, children: "Unable to load road test eligibility requirements" }),
        /* @__PURE__ */ e(I, { variant: "body2", children: n }),
        /* @__PURE__ */ e(y, { sx: { mt: 2 }, children: /* @__PURE__ */ e(
          N,
          {
            color: "error",
            size: "small",
            variant: "outlined",
            disabled: !i,
            onClick: () => i?.(),
            children: "Retry"
          }
        ) })
      ] })
    ] });
  if (!t || !t.hasRequirementsConfig) return null;
  const o = t.requirements, g = o?.drivingMinutesRequired ?? 0, w = o?.observationMinutesRequired ?? 0, R = t.documents ?? [], P = Ke(
    g,
    o?.drivingMinutesCompleted ?? 0
  ), W = Ke(
    w,
    o?.observationMinutesCompleted ?? 0
  ), D = !!t.isReadyForAdminReview, C = !!t.canBookRoadTest, z = (k, ae = "Complete") => /* @__PURE__ */ a(y, { sx: { display: "flex", alignItems: "center" }, children: [
    k ? /* @__PURE__ */ e(we, { sx: { fontSize: 18, mr: 0.5, color: "success.main" } }) : /* @__PURE__ */ e(Ie, { sx: { fontSize: 18, mr: 0.5, color: "text.secondary" } }),
    /* @__PURE__ */ e(
      I,
      {
        variant: "body2",
        color: k ? "success.main" : "text.secondary",
        children: k ? ae : "Pending"
      }
    )
  ] }), O = () => {
    if (u) {
      if (C) {
        u.onToggle();
        return;
      }
      b(!0);
    }
  }, X = D ? "Student passed all requirements. Please make sure you double checked documents before approving road test booking." : "Not all requirements are complete. Are you sure you want to approve this student for road test booking?", Z = u ? /* @__PURE__ */ a(y, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
    /* @__PURE__ */ e(
      I,
      {
        variant: "body2",
        sx: {
          fontWeight: 600,
          color: C ? "success.main" : "text.secondary",
          whiteSpace: "nowrap"
        },
        children: C ? "Approved" : "Not approved"
      }
    ),
    /* @__PURE__ */ e(
      Se,
      {
        size: "small",
        checked: C,
        onChange: O,
        disabled: u.isLoading,
        slotProps: {
          input: {
            "aria-label": C ? "Unapprove road test booking" : "Approve road test booking"
          }
        }
      }
    )
  ] }) : null, E = `/location-search?lesson-type=${xr.RoadTest}`, $ = !u;
  return /* @__PURE__ */ a(Oe, { elevation: h, sx: S, children: [
    /* @__PURE__ */ e(
      $e,
      {
        title: /* @__PURE__ */ e(I, { variant: "h6", children: "Road Test Eligibility Requirements" }),
        action: Z
      }
    ),
    /* @__PURE__ */ a(Pe, { sx: { pt: 0 }, children: [
      /* @__PURE__ */ e(ve, { size: "small", sx: { tableLayout: "fixed", width: "100%" }, children: /* @__PURE__ */ a(xe, { children: [
        s && /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { sx: re, children: "Admin Review" }),
          /* @__PURE__ */ e(F, { children: t.isReadyForAdminReview ? "Ready for review" : "In progress" })
        ] }),
        /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { sx: re, children: "Eligibility Date" }),
          /* @__PURE__ */ e(F, { children: cn(t.eligibilityDate) })
        ] }),
        o?.requiresCourseCompletion && /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { sx: re, children: "Course Requirement" }),
          /* @__PURE__ */ e(F, { children: sn(t.courseStatus) })
        ] }),
        g > 0 && /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { sx: re, children: "Driving Requirement" }),
          /* @__PURE__ */ e(F, { children: /* @__PURE__ */ a(
            y,
            {
              sx: { display: "flex", flexDirection: "column", gap: 1 },
              children: [
                /* @__PURE__ */ a(I, { variant: "body1", children: [
                  P.hoursCompleted,
                  "h / ",
                  P.hoursRequired,
                  "h"
                ] }),
                /* @__PURE__ */ e(
                  pe,
                  {
                    variant: "determinate",
                    value: P.progressPercent,
                    sx: { height: 10, borderRadius: 1 }
                  }
                )
              ]
            }
          ) })
        ] }),
        w > 0 && /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { sx: re, children: "Observation Requirement" }),
          /* @__PURE__ */ e(F, { children: /* @__PURE__ */ a(
            y,
            {
              sx: { display: "flex", flexDirection: "column", gap: 1 },
              children: [
                /* @__PURE__ */ a(I, { variant: "body1", children: [
                  W.hoursCompleted,
                  "h /",
                  " ",
                  W.hoursRequired,
                  "h"
                ] }),
                /* @__PURE__ */ e(
                  pe,
                  {
                    variant: "determinate",
                    value: W.progressPercent,
                    sx: { height: 10, borderRadius: 1 }
                  }
                )
              ]
            }
          ) })
        ] })
      ] }) }),
      R.length > 0 && /* @__PURE__ */ a(y, { sx: { pt: 1 }, children: [
        /* @__PURE__ */ e(
          I,
          {
            variant: "subtitle2",
            color: "text.secondary",
            sx: { mb: 1 },
            children: "Required documents"
          }
        ),
        /* @__PURE__ */ e(ve, { size: "small", children: /* @__PURE__ */ e(xe, { children: R.map((k) => /* @__PURE__ */ a(Q, { children: [
          /* @__PURE__ */ e(F, { children: k.label }),
          /* @__PURE__ */ e(F, { align: "right", children: z(k.isUploaded, "Uploaded") })
        ] }, k.documentId)) }) }),
        !t.requiredDocumentsComplete && l && /* @__PURE__ */ e(
          N,
          {
            variant: "outlined",
            size: "small",
            sx: {
              mt: 1,
              textTransform: "none",
              borderColor: "divider",
              fontWeight: 500
            },
            onClick: l,
            children: c
          }
        )
      ] }),
      $ && /* @__PURE__ */ e(y, { sx: { pt: 1 }, children: /* @__PURE__ */ e(ve, { size: "small", sx: { tableLayout: "fixed", width: "100%" }, children: /* @__PURE__ */ e(xe, { children: /* @__PURE__ */ a(Q, { children: [
        /* @__PURE__ */ e(F, { sx: re, children: "Booking Approval" }),
        /* @__PURE__ */ e(F, { children: /* @__PURE__ */ a(
          y,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap"
            },
            children: [
              /* @__PURE__ */ e(
                I,
                {
                  variant: "body2",
                  sx: {
                    fontWeight: 600,
                    color: C ? "success.main" : "text.secondary"
                  },
                  children: C ? "Approved for road test booking" : "Not approved for road test booking"
                }
              ),
              C && /* @__PURE__ */ e(
                N,
                {
                  size: "small",
                  variant: "contained",
                  href: E,
                  sx: { textTransform: "none" },
                  children: "Book Road Test Lesson"
                }
              )
            ]
          }
        ) })
      ] }) }) }) }),
      u && /* @__PURE__ */ a(
        fe,
        {
          open: v,
          onClose: () => b(!1),
          children: [
            /* @__PURE__ */ e(Te, { children: "Approve for road test booking?" }),
            /* @__PURE__ */ e(ge, { children: /* @__PURE__ */ e(I, { variant: "body2", children: X }) }),
            /* @__PURE__ */ a(ke, { children: [
              /* @__PURE__ */ e(
                N,
                {
                  onClick: () => b(!1),
                  disabled: u.isLoading,
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ e(
                N,
                {
                  variant: "contained",
                  onClick: () => {
                    b(!1), u.onToggle();
                  },
                  disabled: u.isLoading,
                  children: "Approve"
                }
              )
            ] })
          ]
        }
      )
    ] })
  ] });
}
function Qn({
  value: t,
  onChange: r,
  includeEmptyOption: n = !1,
  emptyOptionLabel: i = "No preference",
  SelectProps: l,
  ...c
}) {
  return /* @__PURE__ */ a(
    H,
    {
      select: !0,
      value: t ?? "",
      onChange: (s) => r(s.target.value),
      SelectProps: { native: !0, ...l },
      ...c,
      children: [
        n ? /* @__PURE__ */ e("option", { value: "", children: i }) : null,
        yr.map((s) => /* @__PURE__ */ e("option", { value: s.code, children: s.label }, s.code))
      ]
    }
  );
}
const dn = "America/Los_Angeles", lt = [
  { label: "Pacific", timeZones: ["America/Los_Angeles"] },
  { label: "Central", timeZones: ["America/Chicago"] },
  { label: "Mountain", timeZones: ["America/Denver"] },
  {
    label: "Eastern",
    timeZones: ["America/New_York", "America/Indiana/Indianapolis"]
  }
];
function un(t) {
  return lt.some(
    (r) => r.timeZones.includes(t ?? "")
  );
}
function hn(t) {
  return t && un(t) ? t : dn;
}
function pn({
  value: t,
  onChange: r,
  label: n = "Time Zone",
  name: i = "timeZone",
  style: l,
  fullWidth: c = !1,
  ...s
}) {
  const h = hn(t);
  return /* @__PURE__ */ e(
    H,
    {
      select: !0,
      fullWidth: c,
      label: n,
      name: i,
      value: h,
      onChange: (d) => r(d.target.value),
      style: c ? l : { minWidth: 200, ...l ?? {} },
      variant: "outlined",
      "data-cy": "timezone-select",
      ...s,
      children: lt.map(({ timeZones: d, label: u }) => [
        /* @__PURE__ */ e(ft, { "data-cy": "timezone-menu-group", children: u }, u),
        d.map((v) => /* @__PURE__ */ e(
          Ce,
          {
            value: v,
            "data-cy": "timezone-menu-item",
            children: v
          },
          v
        ))
      ])
    }
  );
}
function Kn({
  label: t,
  addAllOption: r = !1,
  includeNoneOption: n = !1,
  noneOptionLabel: i = "None",
  entityId: l,
  entities: c,
  onChange: s,
  size: h = "medium",
  isLoading: d = !1,
  dataCy: u = "entity-select",
  name: v = "entity"
}) {
  const b = [...c].sort(
    (o, g) => o.name.localeCompare(g.name)
  ), S = (o) => {
    const g = o.target.value, w = g === "all" || g === "" ? null : b.find((R) => R.id === g) ?? null;
    s(w);
  };
  return !d && b.length === 0 ? null : /* @__PURE__ */ a(
    H,
    {
      select: !0,
      name: v,
      label: t ?? "Entity",
      value: l,
      onChange: S,
      variant: "outlined",
      size: h,
      fullWidth: !0,
      disabled: d,
      sx: {
        minWidth: 200,
        "& .MuiSelect-select": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      },
      "data-cy": u,
      children: [
        r ? /* @__PURE__ */ e(Ce, { value: "all", "data-cy": `${u}-option`, children: "All" }) : null,
        n ? /* @__PURE__ */ e(Ce, { value: "", "data-cy": `${u}-option`, children: i }) : null,
        b.map((o) => /* @__PURE__ */ e(
          Ce,
          {
            value: o.id,
            "data-cy": `${u}-option`,
            children: o.name
          },
          o.id
        ))
      ]
    }
  );
}
function ei({
  values: t,
  onChange: r,
  onSubmit: n,
  instructorField: i,
  stateField: l,
  submitButton: c,
  maxEnrolleesHelperText: s,
  allowCohortMakeupRequests: h = !1
}) {
  return /* @__PURE__ */ a("form", { onSubmit: n, children: [
    /* @__PURE__ */ e(
      H,
      {
        name: "stateId",
        label: "Cohort ID",
        value: t.stateId,
        placeholder: "DDMM-YYYYAH###",
        onChange: (d) => r("stateId", d.target.value),
        margin: "normal",
        fullWidth: !0,
        required: !0
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        name: "name",
        label: "Name",
        value: t.name,
        placeholder: "Like 'May 2023, Sundays only",
        onChange: (d) => r("name", d.target.value),
        margin: "normal",
        fullWidth: !0,
        required: !0,
        helperText: "This is a public-facing field the students will see."
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        name: "description",
        label: "Description",
        value: t.description,
        onChange: (d) => r("description", d.target.value),
        margin: "normal",
        fullWidth: !0,
        helperText: "This is also public-facing and can be a longer description about the cohort"
      }
    ),
    i,
    i ? /* @__PURE__ */ e(
      Le,
      {
        control: /* @__PURE__ */ e(
          Se,
          {
            name: "updateSessionsInstructor",
            checked: !!t.updateSessionsInstructor,
            onChange: (d) => r("updateSessionsInstructor", d.target.checked)
          }
        ),
        label: "Automatically apply this change to all sessions",
        sx: { mb: 2 }
      }
    ) : null,
    /* @__PURE__ */ e(
      H,
      {
        name: "videoConferenceUrl",
        label: "Video Conference Link",
        value: t.videoConferenceUrl ?? "",
        onChange: (d) => r("videoConferenceUrl", d.target.value),
        margin: "normal",
        fullWidth: !0,
        placeholder: "https://zoom.us/j/123456789 or https://meet.google.com/xyz-abc-def",
        helperText: "Link to Zoom, Google Meet, or other video conferencing platform"
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        type: "date",
        name: "startDate",
        label: "Start Date",
        value: t.startDate,
        onChange: (d) => r("startDate", d.target.value),
        margin: "normal",
        sx: { mr: 2 },
        required: !0,
        slotProps: {
          inputLabel: { shrink: !0 }
        }
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        type: "date",
        name: "endDate",
        label: "End Date",
        value: t.endDate,
        onChange: (d) => r("endDate", d.target.value),
        margin: "normal",
        required: !0,
        slotProps: {
          inputLabel: { shrink: !0 }
        }
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        type: "number",
        name: "maxEnrollees",
        label: "Maximum Enrollees",
        value: t.maxEnrollees,
        onChange: (d) => {
          const u = parseInt(d.target.value, 10);
          r("maxEnrollees", Number.isNaN(u) ? 0 : u);
        },
        margin: "normal",
        required: !0,
        fullWidth: !0,
        helperText: s,
        slotProps: {
          inputLabel: { shrink: !0 }
        }
      }
    ),
    /* @__PURE__ */ e(y, { sx: { mb: 2 }, children: l }),
    /* @__PURE__ */ e(y, { children: /* @__PURE__ */ e(
      pn,
      {
        value: t.timeZone,
        onChange: (d) => r("timeZone", d)
      }
    ) }),
    /* @__PURE__ */ e(
      Le,
      {
        control: /* @__PURE__ */ e(
          Se,
          {
            name: "isEnrollmentOpen",
            checked: t.isEnrollmentOpen,
            onChange: (d) => r("isEnrollmentOpen", d.target.checked)
          }
        ),
        label: "Is Enrollment Open",
        sx: { mb: 2 }
      }
    ),
    h ? /* @__PURE__ */ e(
      Le,
      {
        control: /* @__PURE__ */ e(
          Se,
          {
            name: "allowMakeupRequests",
            checked: !!t.allowMakeupRequests,
            onChange: (d) => r("allowMakeupRequests", d.target.checked)
          }
        ),
        label: "Allow Make-up Requests",
        sx: { mb: 2 }
      }
    ) : null,
    c
  ] });
}
const mn = 40;
function ti(t = mn) {
  const [r, n] = Y(0), [i, l] = Y(t);
  return {
    queryVariables: {
      first: i,
      skip: r * i
    },
    paginatedTableProps: {
      pageNumber: r,
      rowsPerPage: i,
      onPageNumberChange: n,
      onRowsPerPageChange: (c) => {
        l(c), n(0);
      }
    }
  };
}
function ri() {
  const [t, r] = Y([0, 0]), n = et(null), i = ue(
    () => (l) => {
      n.current?.disconnect(), !(!l || typeof window > "u") && (n.current = new ResizeObserver((c) => {
        const s = c[0], h = s?.contentRect?.width ?? 0, d = s?.contentRect?.height ?? 0;
        r([h, d]);
      }), n.current.observe(l));
    },
    []
  );
  return he(() => () => n.current?.disconnect(), []), { ref: i, width: t[0], height: t[1] };
}
const fn = "1fff660fe49e74cd7fa8", ni = ({
  formId: t,
  title: r = "Stay Updated",
  description: n = "Get the latest updates and offers delivered to your inbox.",
  buttonText: i = "Subscribe",
  placeholder: l = "Enter your email address",
  successMessage: c = "Thanks for subscribing! We'll be in touch soon.",
  additionalFields: s = {},
  onSubmit: h,
  onSuccess: d
}) => {
  const [u, v] = Y(""), [b, S] = Y(!1), [o, g] = Y(!1), [w, R] = Y(""), [, P] = Y(!1);
  he(() => {
    if (document.querySelector("#cio-forms-handler")) {
      P(!0);
      return;
    }
    const C = document.createElement("script");
    C.type = "text/javascript", C.async = !0, C.id = "cio-forms-handler", C.setAttribute("data-site-id", fn), C.setAttribute("data-base-url", "https://customerioforms.com"), C.src = "https://customerioforms.com/assets/forms.js";
    const z = document.getElementsByTagName("script")[0];
    return z.parentNode?.insertBefore(C, z), C.onload = () => P(!0), C.onerror = () => {
      P(!0);
    }, () => {
      C.parentNode && C.parentNode.removeChild(C);
    };
  }, []);
  const W = async (D) => {
    if (D.preventDefault(), R(""), !u || !u.includes("@")) {
      R("Please enter a valid email address");
      return;
    }
    S(!0);
    try {
      h && await h(u, s), g(!0), d && d(u);
    } catch (C) {
      const z = C instanceof Error ? C.message : "Something went wrong. Please try again.";
      R(z);
    } finally {
      S(!1);
    }
  };
  return o ? /* @__PURE__ */ e(y, { sx: { textAlign: "center", p: 2 }, children: /* @__PURE__ */ e(ie, { severity: "success", sx: { mb: 2 }, children: c }) }) : /* @__PURE__ */ a(y, { children: [
    r && /* @__PURE__ */ e(I, { variant: "h6", component: "h3", sx: { mb: 1 }, children: r }),
    n && /* @__PURE__ */ e(I, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: n }),
    /* @__PURE__ */ e("form", { onSubmit: W, "data-form-id": t, name: t, children: /* @__PURE__ */ a(y, { sx: { display: "flex", flexDirection: "column", gap: 2 }, children: [
      /* @__PURE__ */ a(
        y,
        {
          sx: {
            display: "flex",
            gap: 1,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "flex-start" }
          },
          children: [
            /* @__PURE__ */ e(
              H,
              {
                type: "email",
                name: "email",
                value: u,
                onChange: (D) => v(D.target.value),
                placeholder: l,
                required: !0,
                size: "small",
                disabled: b,
                sx: { flex: 1 }
              }
            ),
            /* @__PURE__ */ e(
              N,
              {
                type: "submit",
                variant: "contained",
                disabled: b || !u,
                sx: {
                  minWidth: { xs: "auto", sm: "120px" },
                  height: "40px"
                },
                children: b ? "Subscribing..." : i
              }
            )
          ]
        }
      ),
      Object.entries(s).map(([D, C]) => /* @__PURE__ */ e("input", { type: "hidden", name: D, value: String(C) }, D)),
      w && /* @__PURE__ */ e(ie, { severity: "error", sx: { mt: 1 }, children: w })
    ] }) })
  ] });
};
export {
  vi as ABOUT,
  Un as AVAILABILITY_WEEKDAYS,
  Ln as ActionDialog,
  Fn as AdminContentSurface,
  Zn as AdminDashboardNavigation,
  Gn as AdminFilterSection,
  qn as AdminFilterSurface,
  Hn as AdminHelpDocsButton,
  Br as AdminHelpDocumentContent,
  Ae as AttachmentPreviewCard,
  Yn as AvailabilityRangeEditor,
  $n as Calendar,
  Dr as CalendarType,
  ei as CohortForm,
  Rn as CollapsibleAlert,
  zn as ConfirmationDialog,
  qr as DEFAULT_AVAILABILITY_RANGE,
  dn as DEFAULT_TIME_ZONE,
  ni as EmailLeadCapture,
  _n as EntityNotesAddDialog,
  Nn as EntityNotesContent,
  Wn as EntityNotesDeleteDialog,
  Bn as EntityNotesHeaderAction,
  Kn as EntitySelect,
  Ci as FOOTER_MISSION,
  wi as FOOTER_SECTIONS,
  si as FeatureIcon,
  ci as FeatureIconType,
  Pr as Flyout,
  Vn as GenericTimelineEvent,
  Lr as HelpFlyoutButton,
  Qn as LanguageSelect,
  Jn as LicensingProgressCard,
  pi as LocationMap,
  xi as NAV_SECTIONS,
  jr as NavigationUserRole,
  Xn as ProgramDeadlineBanner,
  yi as RESOURCES,
  fi as RadixDesktopNav,
  gi as RadixMobileNav,
  Ai as SCHOOL_LICENSE_NUMBERS,
  ui as SwipeCarousel,
  lt as TIME_ZONE_GROUPS,
  On as Table,
  pn as TimeZoneSelect,
  jn as Timeline,
  Ti as createAdminTheme,
  ki as createCustomerTheme,
  Wr as findAdminHelpDocForPath,
  un as isSupportedTimeZone,
  hn as normalizeTimeZone,
  ri as useElementSize,
  ai as useInterval,
  Pn as useModal,
  ti as usePagination,
  ze as withModalTargetSafe
};
